import template from "./customer-login-page.html.twig";

Packlab.Component.register('customer-login-page', {
    template: template
});